import { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { NavigationService } from '@seven1/angular-storyblok/layout';

export const navigationDeactivateGuard: CanDeactivateFn<any> = (route) => {
    const service = inject(NavigationService);
    service.closeNav();
    return true;
};
